<template>
  <div id="basketball_playerDetail_seasonData">
    <div class="select_row_box">
      <SelectItem
        v-for="selectItem in selectList"
        :key="selectItem.state"
        :options="selectItem"
        :curVal="selectItem.curVal"
        @changeValEvent="selectChangeVal"
      ></SelectItem>
    </div>
    <div
      class="group_box"
      v-for="group in groupTableList"
      :key="group.tableKey"
    >
      <span
        class="teamName"
        v-show="
          group.tableData && group.tableData.length === 0 && !group.loading
        "
        v-text="group.tableTitle"
      ></span>
      <div class="table_container" ref="tableParentDom">
        <template
          v-if="group.tableColumnData && group.tableColumnData.length > 0"
        >
          <nodeTree_table
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :tableMode="group.tableMode"
            :parentWidthPx="parentWidthPx"
            :isScrollFlag="group.isScrollFlag"
            :isClickFlag="group.isClickFlag"
            :variableColWidthVw="group.variableColWidthVw"
            :tableCellDefaultWidthVw="group.tableCellDefaultWidthVw"
            :defaultWidthVwNum="group.defaultWidthVwNum"
            :tableColumnData="group.tableColumnData"
            :tableData="group.tableData"
            :tableHeightPx="0"
            @clickColumnEvent="clickColumn"
            :initColumnIndex="group.initColumnIndex"
            :tableKey="group.tableKey"
            :jumpRouterPathNames="jumpRouterPathNames"
            v-show="group.tableData && group.tableData.length > 0"
          ></nodeTree_table>
        </template>
      </div>
      <span
        class="noDataClass"
        v-show="
          group.tableData && group.tableData.length === 0 && !group.loading
        "
      >
        暂无数据
      </span>
    </div>
  </div>
</template>
<script>
import {
  https_playerDetail_seasonList,
  https_playerDetail_seasonStatList,
  https_playerDetail_homeawaystat,
  https_playerDetail_winloststat,
  https_playerDetail_againststat,
} from '@api/platfrom_basketball_api'

import SelectItem from '@components/platfromBase/basketball/selectItem.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'

export default {
  name: 'basketball_playerDetail_seasonData',
  components: { SelectItem, nodeTree_table },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      loading: false,
      jumpRouterPathNames: {
        pathName_teamDetail: 'teamDetailIndex',
        pathName_playerDetail: 'playerDetailIndex',
      },
      parentWidthPx: 0,
      parentHeightPx: 0,
      tableMode: 'teamData',
      isScrollFlag: true,
      isClickFlag: true,
      variableColWidthVw: 13.88,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      groupTableList: [
        {
          loading: false,
          tableTitle: '赛季',
          tableKey: 'season',
          tableMode: 'teamData',
          isScrollFlag: true,
          isClickFlag: false,
          variableColWidthVw: 13.88,
          tableCellDefaultWidthVw: 5.55,
          defaultWidthVwNum: null,
          tableColumnData: [],
          tableData: null,
        },
        {
          loading: false,
          tableTitle: '主客队',
          tableKey: 'homeAwayTeam',
          tableMode: 'teamData',
          isScrollFlag: true,
          isClickFlag: true,
          variableColWidthVw: 13.88,
          tableCellDefaultWidthVw: 5.55,
          defaultWidthVwNum: null,
          tableColumnData: [],
          tableData: null,
          sortKey: '',
          asc: false,
          initColumnIndex: 1,
        },
        {
          loading: false,
          tableTitle: '胜负',
          tableKey: 'winLose',
          tableMode: 'teamData',
          isScrollFlag: true,
          isClickFlag: true,
          variableColWidthVw: 13.88,
          tableCellDefaultWidthVw: 5.55,
          defaultWidthVwNum: null,
          tableColumnData: [],
          tableData: null,
          sortKey: '',
          asc: false,
          initColumnIndex: 1,
        },
        {
          loading: false,
          tableTitle: '对阵球队',
          tableKey: 'lineup',
          tableMode: 'teamData',
          isScrollFlag: true,
          isClickFlag: true,
          variableColWidthVw: 13.88,
          tableCellDefaultWidthVw: 5.55,
          defaultWidthVwNum: null,
          tableColumnData: [],
          tableData: null,
          sortKey: '',
          asc: false,
          initColumnIndex: 1,
        },
      ],
      selectList: [
        {
          list: [],
          keyValArr: ['seasonId', 'seasonName'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'seasonType',
        },
        {
          list: [
            {
              id: '1',
              name: '常规赛',
            },
            {
              id: '2',
              name: '季后赛',
            },
            {
              id: '9',
              name: '保级赛',
            },
          ],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'phaseType',
        },
        {
          list: [
            {
              id: '1',
              name: '基础数据',
            },
            // {
            //   id: '2',
            //   name: '高阶数据',
            // },
          ],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'dataType',
        },
        {
          list: [
            {
              id: 'sum',
              name: '总和',
            },
            {
              id: 'avg',
              name: '场均数据',
            },
          ],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'statsType',
        },
      ],
      curSelect_seasonType: '',
      curSelect_phaseType: '1',
      curSelect_dataType: '1',
      curSelect_statsType: 'avg',
    }
  },
  watch: {
    $route(to, from) {
      // 监听路由变化，矫正 tab 选中状态
      console.debug('$route:', from.query, to.query)
      if (JSON.stringify(from.query) !== JSON.stringify(to.query)) {
        // 头部切换球员时刷新数据
        this.query = to.query
        this.init()
      }
    },
  },
  created() {
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.jumpRouterPathNames = {
        pathName_teamDetail: `teamDetailIndex_${moduleRouteNameEn}`,
        pathName_playerDetail: `playerDetailIndex_${moduleRouteNameEn}`,
      }
    }
    const query = this.$route.query
    this.query = query
    this.init()
  },
  mounted() {
    this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
    console.debug('this.parentWidthPx:', this.$refs.tableParentDom.scrollHeight)
  },
  computed: {
    noData() {
      return this.tableData && this.tableData.length === 0 && !this.loading
    },
  },
  methods: {
    async init() {
      if (this.query) {
        window.mixtmtBase_eventBus.$emit('loadingEvent', true)
        await this.getSelectList(this.query)
        await this.makeTaskQueueList(this.query)
        window.mixtmtBase_eventBus.$emit('loadingEvent', false)
      }
    },
    initSelectOpt() {
      let selectList = this.selectList
      this.selectList = selectList.map((item) => {
        if (item) {
          item.curVal = this[`curSelect_${item.state}`]
        }
        return item
      })
    },
    async makeTaskQueueList(query, tableKeyList) {
      let refreshTableKeyList = []
      if (tableKeyList) {
        // 指定刷新单个或多个表格
        refreshTableKeyList = tableKeyList
      } else {
        // 刷新全部表格
        refreshTableKeyList = ['season', 'homeAwayTeam', 'winLose', 'lineup']
      }
      let taskQueueList = []
      this.groupTableList.forEach(async (groupItem) => {
        if (
          refreshTableKeyList.includes(groupItem.tableKey) &&
          groupItem.tableKey === 'season'
        ) {
          groupItem.loading = true
          taskQueueList.push({
            tableKey: groupItem.tableKey,
            originGroupTableItem: JSON.parse(JSON.stringify(groupItem)),
            apiErrorFlag: false,
            params: {
              sid: this.curSelect_seasonType,
              phid: this.curSelect_phaseType,
              tid: query.tid,
              pid: query.pid,
              stat: this.curSelect_statsType,
            },
          })
        } else if (refreshTableKeyList.includes(groupItem.tableKey)) {
          groupItem.loading = true
          taskQueueList.push({
            tableKey: groupItem.tableKey,
            originGroupTableItem: JSON.parse(JSON.stringify(groupItem)),
            apiErrorFlag: false,
            params: {
              sid: this.curSelect_seasonType,
              phid: this.curSelect_phaseType,
              tid: query.tid,
              pid: query.pid,
              stat: this.curSelect_statsType,
              sort: groupItem.sortKey,
              asc: groupItem.asc,
            },
          })
        }
      })
      await this.sendApiQueue(taskQueueList)
    },
    clickColumn(prop) {
      // 多个表格点击排序事件
      console.debug('clickColumn:', prop)
      let tableKeyList = []
      if (prop && typeof prop === 'object') {
        tableKeyList = [prop.tableKey]
        this.groupTableList.forEach((groupItem) => {
          if (groupItem.tableKey === prop.tableKey) {
            groupItem.sortKey = prop.sortKey
          }
        })
        this.makeTaskQueueList(this.query, tableKeyList)
      } else {
        this.makeTaskQueueList(this.query)
      }
    },
    selectChangeVal(data) {
      console.debug('selectChangeVal:', data)
      if (data.state === 'seasonType') {
        this.curSelect_seasonType = data.val
      } else if (data.state === 'phaseType') {
        this.curSelect_phaseType = data.val
      } else if (data.state === 'dataType') {
        this.curSelect_dataType = data.val
      } else if (data.state === 'statsType') {
        this.curSelect_statsType = data.val
      }
      this.makeTaskQueueList(this.query)
      console.debug(this.curSelect_dataType, this.curSelect_seasonType)
    },
    formatTableDataHandler(originTableItem, res) {
      let groupTableItem = JSON.parse(JSON.stringify(originTableItem))
      if (
        res.data &&
        res.data.middle &&
        res.data.datas &&
        res.data.datas.length
      ) {
        const leftColumns = res.data.left
        const middleColumns = res.data.middle
        const rightColumns = res.data.right
        // const fristColumns_left = leftColumns.slice(0, 3)
        // const otherColumns_left = leftColumns.slice(3)
        groupTableItem.defaultWidthVwNum = res.data.middle.length
        let tableColumnData = []
        let leftColumnObjArr = []
        let rightColumnObjArr = []
        for (let i = 0; i < leftColumns.length; i++) {
          const item = leftColumns[i]
          leftColumnObjArr.push({
            prop: item.colKey,
            label: item.colTitle,
            widthVw: groupTableItem.variableColWidthVw, //对应列的宽度，单位vw
            className: 'customCloTextAlignLeft', //单独定制的头部样式class
            fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            selected: groupTableItem.isClickFlag ? item.selected : false,
          })
        }

        // const fristColumn = {
        //   prop: 'leftTeamName', //fristColumnPropArr.join('-'),
        //   label: '球队',
        //   widthVw: groupTableItem.variableColWidthVw, //对应列的宽度，单位vw
        //   className: 'columnTeamNameClass', //单独定制的头部样式class
        //   fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
        // }

        tableColumnData = [].concat(leftColumnObjArr)
        for (let i = 0; i < middleColumns.length; i++) {
          const item = middleColumns[i]
          tableColumnData.push({
            prop: item.colKey,
            label: item.colTitle,
            widthVw: groupTableItem.tableCellDefaultWidthVw, //对应列的宽度，单位vw
            className: '', //单独定制的头部样式class
            selected: groupTableItem.isClickFlag ? item.selected : false,
          })
        }

        for (let i = 0; i < rightColumns.length; i++) {
          rightColumnObjArr.push({
            prop: item.colKey,
            label: item.colTitle,
            widthVw: groupTableItem.variableColWidthVw, //对应列的宽度，单位vw
            className: 'columnTeamNameClass', //单独定制的头部样式class
            fixed: 'right', //是否锁定，如果开启不滚动，此字段无效
            selected: groupTableItem.isClickFlag ? item.selected : false,
          })
        }

        groupTableItem.tableColumnData = [].concat(
          tableColumnData,
          rightColumnObjArr
        )

        groupTableItem.tableColumnData.forEach((colItem, colIndex) => {
          if (colItem.selected) {
            groupTableItem.initColumnIndex = colIndex
          }
        })

        groupTableItem.tableData = res.data ? res.data.datas : []
        console.debug('groupTableItem.tableData:', groupTableItem.tableData)
      } else {
        console.debug('暂无数据')
        groupTableItem.tableData = []
      }
      return groupTableItem
    },
    async getSelectList(params) {
      await https_playerDetail_seasonList(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data) {
              let selectList = this.selectList
              this.curSelect_seasonType = res.data[0].seasonId + ''
              selectList[0].list = res.data.map((item) => {
                item.seasonId = item.seasonId + ''
                return item
              })
              this.selectList = selectList

              this.initSelectOpt()
            } else {
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async sendApiQueue(taskQueueList) {
      let groupTableList = JSON.parse(JSON.stringify(this.groupTableList))
      let axiosAllApiList = []
      await taskQueueList.forEach(async (taskItem) => {
        if (taskItem.tableKey === 'season') {
          axiosAllApiList.push(
            https_playerDetail_seasonStatList(
              this.axiosBaseUrl,
              this.$axios,
              taskItem.params
            )
          )
        } else if (taskItem.tableKey === 'homeAwayTeam') {
          axiosAllApiList.push(
            https_playerDetail_homeawaystat(
              this.axiosBaseUrl,
              this.$axios,
              taskItem.params
            )
          )
        } else if (taskItem.tableKey === 'winLose') {
          axiosAllApiList.push(
            https_playerDetail_winloststat(
              this.axiosBaseUrl,
              this.$axios,
              taskItem.params
            )
          )
        } else if (taskItem.tableKey === 'lineup') {
          axiosAllApiList.push(
            https_playerDetail_againststat(
              this.axiosBaseUrl,
              this.$axios,
              taskItem.params
            )
          )
        }
      })

      Promise.all(axiosAllApiList)
        .then((response) => {
          const resArr = response
          // taskItem.res = res
          console.debug('apiRes:', 2, resArr)
          resArr.forEach((resData, resDataIndex) => {
            const res = resData.data
            if (res.status === 0) {
              let groupItem = taskQueueList[resDataIndex].originGroupTableItem
              let groupTableItem = this.formatTableDataHandler(groupItem, res)
              groupTableItem.loading = false
              taskQueueList[resDataIndex].groupTableItem = groupTableItem
            } else {
              taskQueueList[resDataIndex].apiErrorFlag = true
            }
          })
          this.groupTableList = groupTableList.map((groupItem) => {
            let newGroupItem = groupItem
            taskQueueList.forEach((taskQueueItem) => {
              console.debug('apiRes:', 3, taskQueueList, taskQueueItem)
              if (taskQueueItem.tableKey === groupItem.tableKey) {
                newGroupItem = taskQueueItem.groupTableItem
              }
            })
            return newGroupItem
          })
          console.debug('apiRes:', 4, taskQueueList)
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#basketball_playerDetail_seasonData {
  .select_row_box {
    padding-top: 2.778vw;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    & > div {
      margin-right: 0.694vw;
    }
  }
  .group_box {
    padding: 1.388vw 0 2.778vw 0;
    .teamName {
      display: block;
      padding-bottom: 0.974vw;
      font-size: 1.25vw;
      font-weight: bold;
    }
  }

  .noDataClass {
    display: block;
    width: 100%;
    line-height: 5.55vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }
}
</style>
